module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--small-d9237b679e1a813fbe77d22b899a8261.jpg";